// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../parse/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var parseWithOptions = convertToFP(fn, 4);
export default parseWithOptions;